import {Avatar} from "@ui";
import PropTypes from "prop-types";
import {useState} from "react";
import {useNavigate} from "react-router-dom";
import userIcon from "../../../assets/images/icon_user.svg";
import useNotificationsFeed from "../../../hooks/notifications/useNotificationsFeed";
import useGetUserInfo from "../../../hooks/useGetUserInfo";
import useIsMobile from "../../../hooks/useIsMobile";
import {useAuthStore} from "../../../store/useAuth.store";
import {getUserAvatarImage, getUserInitials} from "../../../util/avatarUtils";
import UserMenu from "../UserMenu";
import styles from "./avatar.module.css";

const MOBILE_BREAKPOINT = 799;

const UserAvatar = ({size = 40}) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile({breakpoint: MOBILE_BREAKPOINT});

  const {data, isLoading} = useGetUserInfo();
  const {unreadCount} = useNotificationsFeed();
  const logout = useAuthStore(state => state.logout);
  const [imageError, setImageError] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  const handleImageError = () => {
    setImageError(true);
  };

  const userInitials = getUserInitials(data);
  const avatarImage = getUserAvatarImage(data);
  const showNotificationBadge = isMobile && unreadCount > 0;

  return (
    <UserMenu handleLogout={handleLogout}>
      <div className={styles.avatarWrapper}>
        <Avatar
          size={size}
          className={`${styles.avatar_icon} ${showNotificationBadge ? styles.avatarPulse : ""}`}
        >
          {isLoading ? (
            <span></span>
          ) : !imageError && avatarImage ? (
            <img
              src={avatarImage || userIcon}
              alt="User Avatar"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "50%",
              }}
              onError={handleImageError}
            />
          ) : (
            <span>{userInitials}</span>
          )}
        </Avatar>
        {showNotificationBadge && (
          <span className={styles.notificationBadge}>{unreadCount > 99 ? "99+" : unreadCount}</span>
        )}
      </div>
    </UserMenu>
  );
};

UserAvatar.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default UserAvatar;
